const HeaderLogin = (function HeaderLogin() {
    const body = document.body;
    const loginDrawer = document.querySelector(".site-header__login");
    const loginClose = document.getElementById("close-login");
    const loginOverlay = document.getElementById("loginOverlay");
    const loginToggles = document.querySelectorAll(".login-toggle");
    let lastTrigger = null;

    function setToggleState(isExpanded) {
        loginToggles.forEach((toggle) => {
            toggle.setAttribute("aria-expanded", String(isExpanded));
        });
    }

    function openLogin(trigger) {
        if (!loginDrawer) {
            return;
        }

        lastTrigger = trigger || lastTrigger;
        loginDrawer.classList.add("is-active");
        loginDrawer.setAttribute("aria-hidden", "false");
        body.style.overflow = "hidden";
        setToggleState(true);
        document.dispatchEvent(new CustomEvent("login:opened"));
    }

    function closeLogin() {
        if (!loginDrawer) {
            return;
        }

        loginDrawer.classList.remove("is-active");
        loginDrawer.setAttribute("aria-hidden", "true");
        body.style.overflow = "";
        setToggleState(false);
        document.dispatchEvent(new CustomEvent("login:closed"));

        if (lastTrigger && typeof lastTrigger.focus === "function") {
            lastTrigger.focus();
        }
    }

    function attachEvents() {
        if (!loginDrawer || !loginClose || !loginOverlay || !loginToggles.length) {
            return;
        }

        loginToggles.forEach((toggle) => {
            toggle.addEventListener("click", function (event) {
                event.preventDefault();
                openLogin(toggle);
            });
        });

        loginClose.addEventListener("click", closeLogin);
        loginOverlay.addEventListener("click", closeLogin);

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && loginDrawer.classList.contains("is-active")) {
                closeLogin();
            }
        });
    }

    function init() {
        if (loginToggles.length) {
            setToggleState(false);
        }

        attachEvents();
    }

    return {
        init,
        openLogin,
        closeLogin
    };
}());

window.addEventListener("load", function () {
    HeaderLogin.init();
});
